import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-ink border-t border-white/5 relative overflow-hidden">

      {/* Watermark character */}
      <div
        className="absolute right-0 bottom-0 font-serif text-white select-none pointer-events-none leading-none"
        style={{ fontSize: '28rem', opacity: 0.018, transform: 'translateX(10%)' }}
      >王</div>

      {/* ── Main content ─────────────────────────────── */}
      <div className="max-w-7xl mx-auto px-6 py-20 border-b border-white/5">
        <div className="grid md:grid-cols-4 gap-12 relative z-10">

          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-6 group">
              <div className="relative w-11 h-11 border border-warm-gold flex items-center justify-center text-warm-gold font-serif font-bold text-lg transition-all duration-300 group-hover:bg-warm-gold group-hover:text-ink">
                <span>王</span>
                <span className="absolute -top-1 -left-1 w-2.5 h-2.5 border-t border-l border-warm-gold"></span>
                <span className="absolute -top-1 -right-1 w-2.5 h-2.5 border-t border-r border-warm-gold"></span>
                <span className="absolute -bottom-1 -left-1 w-2.5 h-2.5 border-b border-l border-warm-gold"></span>
                <span className="absolute -bottom-1 -right-1 w-2.5 h-2.5 border-b border-r border-warm-gold"></span>
              </div>
              <div>
                <span className="block font-serif text-white text-lg font-bold leading-tight">Tastywood</span>
                <span className="block text-warm-gold text-xs tracking-[0.3em] uppercase mt-0.5">Toronto · Canada</span>
              </div>
            </Link>
            <p className="text-white/25 text-sm leading-relaxed">
              Authentic Chinese cuisine with a Canadian soul, served with elegance since 2020.
            </p>
            {/* Decorative divider */}
            <div className="flex items-center gap-2 mt-6">
              <div className="h-px w-8 bg-warm-gold/30"></div>
              <span className="text-warm-gold/40 text-xs">✦</span>
              <div className="h-px flex-1 bg-warm-gold/10"></div>
            </div>
          </div>

          {/* Navigate */}
          <div>
            <h4 className="text-warm-gold text-xs tracking-[0.35em] uppercase mb-6 pb-3 border-b border-white/5">Navigate</h4>
            <ul className="space-y-3">
              {[['/', 'Home'], ['/menu', 'Menu'], ['/gallery', 'Gallery'], ['/contact', 'Contact']].map(([to, label]) => (
                <li key={to}>
                  <Link
                    to={to}
                    className="text-white/35 hover:text-warm-gold text-sm transition-colors duration-300 flex items-center gap-2 group"
                  >
                    <span className="text-warm-gold/0 group-hover:text-warm-gold/60 transition-colors text-xs">—</span>
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h4 className="text-warm-gold text-xs tracking-[0.35em] uppercase mb-6 pb-3 border-b border-white/5">Hours</h4>
            <ul className="space-y-4 text-sm">
              <li>
                <div className="text-white/50 mb-0.5">Monday – Friday</div>
                <div className="text-white/25">11:00 AM – 10:00 PM</div>
              </li>
              <li>
                <div className="text-white/50 mb-0.5">Saturday – Sunday</div>
                <div className="text-white/25">10:00 AM – 11:00 PM</div>
              </li>
              <li className="pt-2 border-t border-white/5">
                <div className="text-imperial-red text-xs tracking-widest uppercase">Reservations recommended</div>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-warm-gold text-xs tracking-[0.35em] uppercase mb-6 pb-3 border-b border-white/5">Contact</h4>
            <ul className="space-y-4 text-sm">
              <li>
                <div className="text-white/35 leading-relaxed">123 Main Street<br />Toronto, ON M5V 1A1</div>
              </li>
              <li>
                <a href="tel:+11234567890" className="text-white/35 hover:text-warm-gold transition-colors">(123) 456-7890</a>
              </li>
              <li>
                <a href="mailto:info@kingsnoodles.ca" className="text-white/35 hover:text-warm-gold transition-colors">info@kingsnoodles.ca</a>
              </li>
            </ul>

            {/* CTA */}
            <Link
              to="/contact"
              className="inline-block mt-8 px-6 py-3 border border-warm-gold/30 text-warm-gold text-xs tracking-[0.25em] uppercase hover:bg-warm-gold hover:text-ink transition-all duration-300"
            >
              Reserve a Table
            </Link>
          </div>
        </div>
      </div>

      {/* ── Bottom Bar ───────────────────────────────── */}
      <div className="max-w-7xl mx-auto px-6 py-6 relative z-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/15 text-xs tracking-widest">
            &copy; 2026 Tastywood Restaurant. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <span className="text-white/15 text-xs">Privacy Policy</span>
            <span className="text-white/10">|</span>
            <span className="text-white/15 text-xs">Terms of Service</span>
            <span className="text-white/10">|</span>
            <Link to="/admin" className="text-white/15 hover:text-white/30 text-xs transition-colors">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
